import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="booking-calendar"
export default class extends Controller {
  set_selected(e) {
    const loader = document.querySelector(this.element.dataset.loaderSelector)
    if (loader) {
      loader.classList.remove('hidden')
    }

    this.element.querySelectorAll('.selected').forEach((element) => {
      element.classList.remove('selected')
    })

    const closest_link = e.target.closest('a')
    if (closest_link) {
      closest_link.classList.add('selected')
    }
  }
}
